import { createFileRoute } from '@tanstack/react-router';

import { AdminSeasonsPage } from '@/components/admin/sport/seasons-page';
import { adminHead } from '@/lib/seo';
import { adminListSeasonsFn } from '@/server/functions/sport';

export const Route = createFileRoute('/_admin/admin/sport/seasons')({
    component: SeasonsRoute,
    head: () => adminHead('עונות', '/admin/sport/seasons'),
    staleTime: 0,
    preloadStaleTime: 0,
    loader: () => adminListSeasonsFn({ data: { limit: 50 } }),
});

function SeasonsRoute() {
    return <AdminSeasonsPage initial={Route.useLoaderData()} />;
}
